import { Button } from "@strapi/design-system";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.css";

const Welcome = ({ isSmallWindow }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.app.userInfo);

  const handleLogout = () => {
    localStorage.clear();
    navigate(`/nomination/login`);
    dispatch({ type: "RESET_STATE" });
  };

  if (!userInfo) return null;
  return (
    <div className={styles.wrapper}>
      {!isSmallWindow && (
        <Button variant="default">
          {t("str_welcome")}, {userInfo?.email}
        </Button>
      )}
      <button onClick={handleLogout} className={styles.btn}>
        <span className={styles.text}>{t("str_logout")}</span>
      </button>
    </div>
  );
};

export default Welcome;
